module.exports = __webpack_public_path__ + "img/info-outline.e3004860.svg";